export const Colors = {
  woodViewSecondary: '#B4436E',
  woodViewPrimary: '#9ED1B6',
  woodViewPrimaryB: '#E3F2EA',
  woodViewWhite: '#FFFFFF',
  woodViewGrey: '#09100E',
  headerTextColor: '#000000',
  wireFrameShame3: '#828282',
};

export default Colors;
